var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.394 13.046L7.8495 18.584C7.0395 19.0535 6 18.485 6 17.5385V6.46252C6 5.51752 7.038 4.94752 7.8495 5.41852L17.394 10.9565C17.5783 11.0617 17.7314 11.2138 17.8379 11.3972C17.9445 11.5807 18.0006 11.7891 18.0006 12.0013C18.0006 12.2134 17.9445 12.4218 17.8379 12.6053C17.7314 12.7888 17.5783 12.9408 17.394 13.046V13.046Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsPlay);
export default __webpack_public_path__ + "static/media/bsPlay.73c236799e03999270a91bb7e28adaed.svg";
export { ForwardRef as ReactComponent };